exports.version = "2.4.13"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 3Y6g
// module chunks = 0